import _getVideoUrl from '@wix/communities-blog-universal/dist/src/utils/media/video';

let _videoHost = '';

export const initVideoUtils = videoHost => (_videoHost = videoHost);

export const getVideoUrl = pathname => _getVideoUrl(_videoHost)(pathname);
